import _ from 'lodash';
import { codeGeneretor } from 'app/utils';

const TEMPLATE_NAME = 'PAD_MODEL_EDITOR';

const initialState = () => ({
  loading: false,
  padModel: {},
  errors: []
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = _.cloneDeep(action.payload);
      const { pad } = newData;
      return {
        ...state,
        loading: false,
        pad: {
          ...pad,
          loadedData: pad
        }
      };
    }

    case `${TEMPLATE_NAME}_SAVE_MODEL`: {
      const newData = action.payload;
      let padModel = newData.data;
      padModel.code = codeGeneretor();
      return {
        ...state,
        loading: false,
        padModel
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
